module.exports = __webpack_public_path__ + "img/logo.648feb03.png";